import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { FeaturedSvg, type IconKey } from "@/components/seo/FeaturedSvg";
import { AdSlot } from "@/components/AdSlot";

const TOOLS: { path: string; title: string; desc: string; icon: IconKey }[] = [
  { path: "/tools/kalkulator-hari", title: "Kalkulator Hari", desc: "Selisih, tambah/kurang, hari kerja, umur.", icon: "since-clock" },
  { path: "/tools/cek-weton", title: "Cek Weton Jawa", desc: "Hari, pasaran, neptu, wuku, watak.", icon: "kartini" },
  { path: "/tools/hari-jadian", title: "Hari Jadian", desc: "Sudah berapa lama jadian sama dia?", icon: "since-heart" },
  { path: "/tools/hari-lahir", title: "Hari Lahir", desc: "Berapa lama kamu hidup sampai sekarang?", icon: "since-cake" },
  { path: "/tools/hari-menikah", title: "Lama Menikah", desc: "Sudah berapa lama menikah dengan dia?", icon: "since-ring" },
  { path: "/tools/hari-putus", title: "Hari Putus / Gamon", desc: "Berapa hari sejak kamu putus?", icon: "since-broken" },
  { path: "/tools/hari-sahabat", title: "Lama Bersahabat", desc: "Sahabatmu - sejak kapan kalian kenal?", icon: "since-friends" },
  { path: "/tools/hari-ldr", title: "Lama LDR-an", desc: "Sudah berapa lama jalani LDR?", icon: "since-ldr" },
];

export const Route = createFileRoute("/tools/")({
  head: () => ({
    meta: [
      { title: "Kalkulator Tanggal & Hari - Hari Jadian, Lahir, Menikah, LDR, Weton" },
      { name: "description", content: "Kumpulan kalkulator tanggal: hari jadian, hari lahir, lama menikah, lama LDR, lama putus, lama bersahabat, kalkulator hari kerja, dan cek weton Jawa." },
      { property: "og:title", content: "Kalkulator Tanggal & Hari Online" },
      { property: "og:description", content: "Hitung hari jadian, lahir, menikah, putus, LDR, weton dan banyak lagi." },
    ],
  }),
  component: ToolsHub,
});

function ToolsHub() {
  return (
    <SiteShell>
      <div className="py-6 md:py-10">
        <header className="mb-6">
          <h1 className="text-3xl font-bold tracking-tight">Kalkulator Tanggal & Hari</h1>
          <p className="mt-2 text-muted-foreground">
            Kumpulan tools gratis untuk hitung hari jadian, hari lahir, lama menikah, LDR, putus, sahabat, hingga cek weton Jawa.
          </p>
        </header>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {TOOLS.map((t) => (
            <Link
              key={t.path}
              to={t.path as never}
              className="group rounded-xl border border-border bg-card p-4 transition hover:border-primary"
            >
              <FeaturedSvg variant="tool" title={t.title} subtitle={t.desc} iconKey={t.icon} className="w-full" />
              <h2 className="mt-3 text-base font-semibold group-hover:text-primary">{t.title}</h2>
              <p className="mt-1 text-sm text-muted-foreground">{t.desc}</p>
            </Link>
          ))}
        </div>
        <div className="mt-8">
          <AdSlot size="rectangle" position="tools-hub" />
        </div>
      </div>
    </SiteShell>
  );
}